module.exports = __webpack_public_path__ + "img/portal-v4.f2e3ddcc.jpg";